module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan1-3-f8e637675df362f248af193f24aa8ab1.webp";